import React, { useEffect, useState } from "react";
import { Drawer } from "@mui/material";
import InviteGroupMember from "./InviteGroupMember";
import InvitePopup from "../../../common/InvitePopup";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { leftOverlayDrawerSx } from "../../../assets/commonFunction";
import { canManageGroup } from "../../../utils/helper";

const AddMemberGroupDrawer = ({
  isaddmemberOpen,
  handleCloseAddPeopleDrawer,
}) => {
  const { selectedGroup, currentUserData } = useAppSelectors();
  const [isInviteOpen, setInviteOpen] = useState(false);
  const allowed = canManageGroup(currentUserData, selectedGroup?.permissionType, selectedGroup?.isExternal);

  // Plain users never see the list; close it if the user's role drops while
  // it's open (e.g. demoted to User live).
  useEffect(() => {
    if (isaddmemberOpen && !allowed) {
      setInviteOpen(false);
      handleCloseAddPeopleDrawer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isaddmemberOpen, allowed]);

  const handleOpenMenu = () => {
    setInviteOpen(true);
  };

  const handleCloseMenu = () => {
    setInviteOpen(false);
  };

  // The member list renders only while the drawer is open (until it has slid
  // out): a persistent drawer keeps its content mounted, and this one is in
  // every profile card and the chat tabs, each with every member of the
  // group (a big group's list is ~20,000 elements, re-rendered with them).
  const open = isaddmemberOpen && allowed;
  const [showList, setShowList] = useState(open);
  useEffect(() => {
    if (open) setShowList(true);
  }, [open]);

  return (
    <React.Fragment>
      {isInviteOpen && allowed && (
        <InvitePopup
          closePopUp={handleCloseMenu}
          isGroupInvite={true}
          groupData={selectedGroup}
        />
      )}
      <Drawer
        sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
        open={open}
        anchor={"left"}
        variant="persistent"
        SlideProps={{ onExited: () => setShowList(false) }}
      >
        {allowed && showList && (
          <InviteGroupMember
            handleCloseAddPeopleDrawer={handleCloseAddPeopleDrawer}
            handleOpenMenu={handleOpenMenu}
            isOpen={open}
          />
        )}
      </Drawer>
    </React.Fragment>
  );
};

export default AddMemberGroupDrawer;
